import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import AdminEventContactItem from "./AdminEventContactItem";
import AdminDndList from "~/Admin/AdminDndList/AdminDndList";
import {loadEventsAction} from "~/Admin/redux/actions/event";


const AdminEventContact = ({match, event, ...props}) => {

    const [selectedId, setSelectedId] = useState(event.contacts[0]?.id || 0);

    const handleOrderChanged = (data) => {
        adminHttp.put('/events/' + event.id + '/contacts/order', {
            data: data.map(i => i.id)
        });
    }

    const handleAdd = () => {
        adminHttp.post('/events/' + event.id + '/contacts').then(res => {
            updated();
        });
    }

    const updated = () => {
        props.dispatch(loadEventsAction());
    };

    const selectedContact = event.contacts.find(item => item.id === selectedId);

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <h3>Event Contacts</h3>
                        </div>
                        <div className="col-4">

                            <AdminDndList
                                key={event.updated_at}
                                onChanged={handleOrderChanged}
                                onSelect={setSelectedId}
                                selected={selectedId}
                                list={event.contacts} />

                            <button
                                onClick={handleAdd}
                                className="btn btn-primary btn-sm w-100">
                                + Add Contact
                            </button>

                        </div>
                        <div className="col-8">
                            {selectedContact && <AdminEventContactItem
                                key={selectedId}
                                onChange={updated}
                                onDelete={updated}
                                contact={selectedContact} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventContact);
